import { Clock } from 'lucide-react';
import { bt } from '@/i18n/bookingI18n';

export function DurationStep({ form, errors, set, lang = 'en' }) {
  const DURATION_OPTIONS = [
    { value: '4h', title: bt(lang, 'durHalfTitle'), subtitle: bt(lang, 'durHalfSub'), desc: bt(lang, 'durHalfDesc'), from: 850 },
    { value: '8h', title: bt(lang, 'durFullTitle'), subtitle: bt(lang, 'durFullSub'), desc: bt(lang, 'durFullDesc'), from: 1500 },
  ];
  return (
    <div data-testid="step-duration" className="animate-fade-in">
      <h2 className="font-heading font-black text-2xl sm:text-3xl text-[#121212] tracking-tight mb-2 text-center">{bt(lang, 'durTitle')}</h2>
      <p className="font-body text-sm text-[#666666] text-center mb-8 sm:mb-10">{bt(lang, 'durSub')}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 max-w-2xl mx-auto">
        {DURATION_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            type="button"
            data-testid={`duration-${opt.value}`}
            onClick={() => set('duration', opt.value)}
            className={`text-left p-6 sm:p-8 rounded-2xl border transition-all duration-300 group ${
              form.duration === opt.value ? 'border-[#EE5A01] bg-[#FFF4ED]' : 'border-black/10 bg-white hover:border-[#EE5A01]/40'
            }`}
          >
            <div className="flex items-center gap-3 mb-4">
              <div className={`w-10 h-10 flex items-center justify-center transition-colors ${form.duration === opt.value ? 'bg-[#EE5A01] text-white' : 'bg-[#F5F5F3] text-[#666666] group-hover:text-[#EE5A01]'}`}>
                <Clock className="w-5 h-5" />
              </div>
              <div>
                <h3 className="font-heading font-bold text-lg text-[#121212]">{opt.title}</h3>
                <p className="font-mono text-xs text-[#EE5A01]">{opt.subtitle}</p>
              </div>
            </div>
            <p className="font-body text-sm text-[#555555] mb-4">{opt.desc}</p>
            <p className="font-heading text-sm text-[#666666]">{bt(lang, 'from')} <span className="font-black text-[#EE5A01] text-lg">AED {opt.from.toLocaleString()}</span></p>
          </button>
        ))}
      </div>
      {errors.duration && <p className="text-[#EE5A01] text-xs mt-4 font-body text-center">{errors.duration}</p>}
    </div>
  );
}
